// extracted by mini-css-extract-plugin
export default {"rafOffer":"Gf807e7"};